export default "__VITE_ASSET__CAyb9mgm__"